import { useEffect, useRef, useState } from "react";

export const Section = ({ id, className = "", testId, bare = false, style, children }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      id={id}
      className={`als-section reveal scroll-mt-16 ${className} ${visible ? "is-visible" : ""}`}
      data-testid={testId}
      style={style}
    >
      {bare ? children : <div className="als-container relative">{children}</div>}
    </section>
  );
};

export const stagger = (i) => ({ "--stagger": `${i * 0.1}s` });

export const slug = (s) =>
  s.toLowerCase().replace(/&/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
